import { useFeatureFlags } from '@usap/core'
import getCookieRegex from '../helpers/getCookieRegex'

const useDeliveryDatesLastMileEnabled = () => {
  const { f103 } = useFeatureFlags()
  if (f103 !== null && f103 !== undefined) {
    return f103 === 'b' || f103 === '1' || f103 === 'c' || f103 === 'on' || String(f103) === 'true'
  }
  return false
}

const useDeliveryDatesLastMileCookie = () => {
  const { f103 } = useFeatureFlags()
  const f103CookieWindow = getCookieRegex('f103')

  if (f103CookieWindow) {
    return f103CookieWindow
  }

  if (f103) {
    return f103
  }

  return null
}

export { useDeliveryDatesLastMileEnabled, useDeliveryDatesLastMileCookie }
